import "./index.scss";
import { HighlightStep } from "components/UI/atoms";
import { HIGHLIGHT_STEPS } from "./utils/constants";

export const SellLandingHighlight = () => (
  <div className="sell-landing-highlight">
    <h2>Earn cash in 3 easy steps.</h2>
    <p>See how much you'll get for selling gift cards and store credits.</p>
    <div className="highlight-list">
      {HIGHLIGHT_STEPS.map((props) => (
        <HighlightStep key={props.title} {...props} />
      ))}
    </div>
  </div>
);
